<template>
  <stacked-bar-with-prior-year
    :chart-data="chartData"
    :loading="loading"
    chart-v-ax-format="percent"
    :bus="bus"
    v-on:bar-selected="triggerBarSelect"
  ></stacked-bar-with-prior-year>
</template>

<script>
import StackedBarWithPriorYear from "../../../charts/StackedBarWithPriorYear.vue";
import Vue from "vue";

export default {
  name: "ConversionPercentage",
  data() {
    return {
      loading: false
    }
  },
  props: ['date-range', 'updateData', 'viewData', 'bus'],
  components: {StackedBarWithPriorYear},
  computed: {
    chartData: function() {
      return this.viewData
    }
  },
  methods: {
    triggerBarSelect(event) {
      this.$emit('conversion-bar-selected', event);
    }
  }
}
</script>

<style scoped>

</style>
